import script from "./VVVKyc.vue?vue&type=script&setup=true&lang=js"
export * from "./VVVKyc.vue?vue&type=script&setup=true&lang=js"

import "./VVVKyc.vue?vue&type=style&index=0&id=016cb6aa&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\CSD.SPA\\ClientApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-016cb6aa"]])

export default __exports__